module.exports = __webpack_public_path__ + "static/media/spongebob.cfac4006.jpg";